import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-percentage-gauge',
  templateUrl: './percentage-gauge.component.html',
  styleUrls: ['./percentage-gauge.component.css']
})
export class PercentageGaugeComponent implements OnInit {

  @Input() gaugePercentage: number = 0;
  @Input() gaugeColor: string;

  gaugePercentageAsString() {
    return `${this.gaugePercentage}%`;
  }

  constructor() { }

    ngOnInit() {
    }
 }
